const GAS_STATION_PRECISION = 3

export const toGasStationNumber = (value: number) =>
  Number(value.toFixed(GAS_STATION_PRECISION))

export const mul = (a: number, b: number) => toGasStationNumber(a * b)
